<template>
  <v-dialog :model-value="isWithdrawDialogActived" max-width="860px" persistent scrollable>
    <v-card class="dialog-card">
      <v-card-title class="dialog-title">
        <span>Retirar Agroquimico{{ getItemsToWithdraw.length > 1 ? 's' : '' }}</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" validate-on="lazy">
          <section class="form-section">
            <h2>Orden de retiro</h2>
            <v-row dense>
              <v-col cols="12" md="5">
                <v-text-field
                  ref="workOrderField"
                  v-model="withdrawOrder.workOrder"
                  label="Nro. de Orden"
                  variant="outlined"
                  density="comfortable"
                  autofocus
                  :rules="[rules.requiredFieldRule]"
                />
              </v-col>
            </v-row>
          </section>

          <section class="form-section">
            <h2>Productos seleccionados</h2>
            <div class="table-wrapper">
              <v-data-table
                :items="getItemsToWithdraw"
                :headers="headers"
                :items-per-page="-1"
                hide-default-footer>
                <template #[`item.amount`]="{ item }">
                  {{ getRawItem(item).amount }}
                </template>
                <template #[`item.withdrawAmt`]="{ item }">
                  <v-text-field
                    v-model="getRawItem(item).withdrawAmt"
                    type="number"
                    label="Cantidad"
                    min="0"
                    :max="getRawItem(item).amount"
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    :rules="[rules.requiredFieldRule, rules.min0, rules.maxV(getRawItem(item).withdrawAmt, getRawItem(item).amount)]"
                  />
                </template>
              </v-data-table>
            </div>
          </section>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" variant="text" @click="close">Cancelar</v-btn>
        <v-btn color="primary" :disabled="!valid" @click="save">Retirar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'WithdrawAgrochemicalForm',
  data: () => ({
    valid: true,
    headers: [
      { title: 'Nombre', key: 'name' },
      { title: 'Cantidad Disponible', key: 'amount' },
      { title: 'Cantidad a retirar', key: 'withdrawAmt', sortable: false }
    ],
    rules: {
      requiredFieldRule: v => !!v || 'Campo requerido.',
      min0: v => (v > 0) || 'Debe ingresar un valor mayor que 0',
      maxV: (v, max) => (v <= max) || 'No puede retirar mas de la cantidad disponible.'
    },
    withdrawOrder: {
      workOrder: '',
      items: []
    }
  }),

  computed: {
    ...mapGetters('agrochemicalModule', ['isWithdrawDialogActived', 'getItemsToWithdraw'])
  },

  methods: {
    getRawItem (item) {
      return item.raw || item
    },

    close () {
      this.valid = true
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
      this.withdrawOrder = {workOrder: '', items: []}
      this.$store.dispatch('agrochemicalModule/setItemsToWithdraw', [])
      this.$store.dispatch('agrochemicalModule/setWithdrawDialogActived', false)
    },

    async save () {
      const validation = await this.$refs.form.validate()
      if (!validation.valid) {
        return
      }
      this.withdrawOrder.items = this.$store.getters['agrochemicalModule/getItemsToWithdraw'].map(item => ({
        id: item.id,
        withdrawAmt: item.withdrawAmt
      }))
      try {
        await this.$store.dispatch('agrochemicalModule/withdrawAgrochemical', this.withdrawOrder)
        this.close()
      } catch (error) {
        console.log('Error withdrawing agrochemical.', error)
      }
    }
  }
}
</script>
